import React from 'react'

// eslint-disable-next-line import/prefer-default-export
export function SvgDot() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="3" height="4" viewBox="0 0 3 4" fill="none">
      <circle cx="1.5" cy="2" r="1.5" fill="#606060" />
    </svg>
  )
}
